import { mapState, mapGetters, mapActions } from 'vuex';

export const authComputed = {
  ...mapState('auth', ['user']),
  ...mapGetters('auth', [
    'loggedIn',
    'userInRole',
  ]),
};

export const authMethods = mapActions('auth', ['logIn', 'logOut']);